// Client/src/partner/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = String(process.env.REACT_APP_SUPABASE_URL || "").trim();
const supabaseAnonKey = String(process.env.REACT_APP_SUPABASE_ANON_KEY || "").trim();

// The browser uses only Supabase's public anon key. It must never receive a
// service-role key, Partner API key, evaluator prompt, or TVAC internal key.
export const hasPartnerWorkspaceSupabaseConfig = Boolean(
  supabaseUrl && supabaseAnonKey
);

export const partnerWorkspaceSupabase = hasPartnerWorkspaceSupabaseConfig
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export function getPartnerWorkspaceRedirectUrl() {
  const url = new URL(window.location.href);
  url.search = "";
  url.hash = "";
  url.searchParams.set("workspace", "partner");
  return url.toString();
}
